export default __webpack_public_path__ + "static/media/129.529a10ca.gif";